import {
  GET_CART_LOGS_SUCCESS,
  GET_CART_LOG_DETAILS_SUCCESS,
  CART_LOGS_LOADING,
} from "./Action";

const initialState = {
  cartLogs: [],
  count: 0,
  cartLogDetails: null,
  load: null,
  error: null,
};

const cartLogsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  
  switch (type) {
    case CART_LOGS_LOADING:
      return {
        ...state,
        load: payload,
      };
    case GET_CART_LOGS_SUCCESS: {
      const list = Array.isArray(payload?.data?.carts)
        ? payload?.data?.carts
        : Array.isArray(payload?.data?.data)
        ? payload?.data?.data
        : Array.isArray(payload?.data)
        ? payload?.data
        : Array.isArray(payload?.carts)
        ? payload?.carts
        : [];

      const total =
        payload?.extra?.total_count ??
        payload?.meta?.total ??
        payload?.total ??
        payload?.extra?.total ??
        0;

      return {
        ...state,
        cartLogs: list,
        count: total,
      };
    }
    case GET_CART_LOG_DETAILS_SUCCESS: {
      const details = payload?.data ?? payload;
      return {
        ...state,
        cartLogDetails: details,
      };
    }
    default:
      return state;
  }
};

export default cartLogsReducer;